import { inject } from '@angular/core';
import { type CanMatchFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { PermissionService } from '@app/auth/permission.service';

/**
 * Loads the permissions for the project route before its child routes are matched.
 * The parent `:projectSlug` route supplies the first URL segment to this guard.
 */
export const projectPermissionLoader: CanMatchFn = (_route, segments) => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    const projectSlug = segments[0]?.path;
    if (!projectSlug) return false;

    return permissionService.loadProjectAccess(projectSlug).pipe(
        map(() => {
            permissionService.setSelectedProject(projectSlug);
            return true;
        }),
        catchError(() => {
            router.navigate(['/not-found']);
            return of(false);
        }),
    );
};
